<template>
    <div class="border-thin rounded-lg p-4 px-3">
        <div class="row g-3 position-relative">
            <h2 class="raised-label">Your billing details</h2>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.forename" arrow placement="top" class="w-100 m-0 border-0" :show="errors.forename ? true : false">
                    <div class="form-floating">
                        <Field id="forename" name="forename" type="text" placeholder="First Name" class="form-control"/>
                        <label for="forename">Forename</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.surname" arrow placement="top" class="w-100 m-0 border-0" :show="errors.surname ? true : false">
                    <div class="form-floating">
                        <Field id="surname" name="surname" type="text" placeholder="Last Name" class="form-control" />
                        <label for="surname">Surname</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.email" arrow placement="top" class="w-100 m-0 border-0" :show="errors.email ? true : false">
                    <div class="form-floating">
                        <Field id="email" name="email" type="text" placeholder="Email Address" class="form-control" />
                        <label for="email">Email</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.postcode ? true : false">
                    <div class="form-floating">
                        <Field id="postcode" name="postcode" type="text" placeholder="Postcode" @keyup="this.$parent.$parent.postcodeLookup($event.target.value, true)" :value="postcode" class="form-control" />
                        <label for="postcode">Postcode</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.telephone" arrow placement="top" class="w-100 m-0 border-0" :show="errors.telephone ? true : false">
                    <div class="form-floating">
                        <Field id="telephone" name="telephone" type="text" placeholder="Telephone Number" class="form-control" />
                        <label for="telephone">Telephone</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.registration" arrow placement="top" class="w-100 m-0 border-0" :show="errors.registration ? true : false">
                    <div class="form-floating">
                        <Field id="registration" name="registration" type="text" placeholder="Registration" v-model="updatedRegistration" class="form-control reg-input" />
                        <label for="registration">Registration</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4">
                <Popper :content="errors.address" arrow placement="top" class="w-100 m-0 border-0" :show="errors.address ? true : false">
                    <div class="form-floating">
                        <Field id="address" v-slot="{ value }" name="address" as="select" class="form-select">
                            <option value="" disabled>Please select your address</option>
                            <template v-for="address, key in addresses">
                                <template v-if="key != 0">
                                    <option :key="key" :value="key" :selected="value && value.includes(address)">{{ address }}</option>
                                </template>
                            </template>
                        </Field>
                        <label for="address">Address</label>
                    </div>
                </Popper>
            </div>
            <div class="col-12 col-sm-4 d-flex align-items-center">
                <label for="input_address_manually" class="d-inline-block cursor-pointer">
                    Input address manually?
                    <Field type="checkbox" id="input_address_manually" name="input_address_manually" class="d-inline-block ms-2 cursor-pointer" :value="true" v-model="inputAddressManually" @click="this.$emit('inputAddressManually')"/>
                </label>
            </div>
            <div class="col-12" v-if="inputAddressManually == true">
                <div class="row g-3">
                    <div class="col-12 col-sm-4">
                        <Popper :content="errors.address1" arrow placement="top" class="w-100 m-0 border-0" :show="errors.address1 ? true : false">
                            <div class="form-floating">
                                <Field id="address1" name="address1" type="text" placeholder="Address 1" class="form-control" />
                                <label for="address1">Address 1</label>
                            </div>
                        </Popper>
                    </div>
                    <div class="col-12 col-sm-4">
                        <Popper :content="errors.address2" arrow placement="top" class="w-100 m-0 border-0" :show="errors.address2 ? true : false">
                            <div class="form-floating">
                                <Field id="address2" name="address2" type="text" placeholder="Address 2" class="form-control" />
                                <label for="address2">Address 2</label>
                            </div>
                        </Popper>
                    </div>
                    <div class="col-12 col-sm-4">
                        <Popper :content="errors.address3" arrow placement="top" class="w-100 m-0 border-0" :show="errors.address3 ? true : false">
                            <div class="form-floating">
                                <Field id="address3" name="address3" type="text" placeholder="Address 3" class="form-control" />
                                <label for="address3">Address 3</label>
                            </div>
                        </Popper>
                    </div>
                    <div class="col-12 col-sm-4">
                        <Popper :content="errors.town" arrow placement="top" class="w-100 m-0 border-0" :show="errors.town ? true : false">
                            <div class="form-floating">
                                <Field id="town" name="town" type="text" placeholder="Town" class="form-control" />
                                <label for="town">Town</label>
                            </div>
                        </Popper>
                    </div>
                    <div class="col-12 col-sm-4">
                        <Popper :content="errors.county" arrow placement="top" class="w-100 m-0 border-0" :show="errors.county ? true : false">
                            <div class="form-floating">
                                <Field id="county" name="county" type="text" placeholder="County" class="form-control" />
                                <label for="county">County</label>
                            </div>
                        </Popper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    import bespoke from '@shared/mixins/bespoke';
    export default {
        props: ['basket', 'registration', 'postcode', 'addresses', 'errors'],
        components: { Field, ErrorMessage },
        mixins: [bespoke],
        data() {
            return {
                inputAddressManually: false,
                updatedRegistration: this.registration
            }
        },
        mounted() {
        },
        methods: {

        }
    }
</script>
<style lang="scss" scoped>
    .reg-input {
        border: 1px solid #ced4da;
        background-color: #fc3 !important;
        color: black;
        font-weight: bold;
        text-transform: uppercase;
        &::placeholder {
            color: black;
            font-weight: normal !important;
        }
    }
</style>